<template>
  <div class="form-group">
    <label :for="name">{{ $t(title)}}
      <span class="text-danger" v-if="required">*</span></label>
    <input :id="name" :name="name" type="email" class="form-control" :placeholder="placeholder" :required="required" v-model="modelProxy">
    <span class="form-text text-muted">{{ hint }}</span>
    <p class="text-danger pt-1 px-3 block" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  props: {
    name:{},
    model:{},
    title:{},
    error: {},
    hint: {},
    placeholder:{},
    required: {
      default: true
    }
  },
  computed: {
    modelProxy: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    }
  },
}
</script>


